/**
 * For maintainability we should separate controllers into their own modules
 */
angular
  .module('acme.view.application.coupons.list.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.permissions',
    'acme.view.application.coupons.list.createCoupon.controllers',
    'acme.view.application.coupons.list.removeCoupon.controllers',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.helpers',
  ])

  .controller('CouponsListController', [
    '$scope',
    '$state',
    '$filter',
    '$timeout',
    '$uibModal',
    'ApiService',
    'PermissionsService',
    'GridStateFactory',
    'GridDefinitionFactory',
    'HelpersService',
    function ($scope, $state, $filter, $timeout, $uibModal, ApiService, PermissionsService, GridStateFactory, GridDefinitionFactory, HelpersService) {
      $scope.couponsList = {
        searchQuery: '',

        isLoaded: false,

        model: [],

        categories: [],

        accounts: [],

        filtered: [],

        gridState: new GridStateFactory(),
        gridDefinition: new GridDefinitionFactory(),
        gridName: $state.current.name + '.grid0',
        viewId: '',

        optionsOverride: {
          data: 'couponsList.model',
          rowClasses:
            "{ 'ui-grid-row-header-cell': col.isRowHeader, 'private-event': (row.entity.type === 'private') || row.entity.offSchedule, 'programs-list-canceled-row': (row.entity.showCanceledState && row.entity.isCanceled) }",
          columnDefs: [
            {
              field: 'id',
              displayName: 'ID',
              visible: false,
            },
            {
              field: 'name',
              displayName: 'name',
            },
            {
              field: 'code',
              displayName: 'code',
            },
            {
              field: 'description',
              displayName: 'description',
            },
          ],
          appScopeProvider: {
            onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
              $scope.couponsList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
            },
            onDataGridSortChange: function (grid, columns, page) {
              $scope.couponsList.onDataGridSortChange(grid, columns, page);
            },
            onDblClick: function (row) {
              $scope.couponsList.onDblClick(row);
            },
            remove: function (row, col) {
              $scope.couponsList.removeCoupon(row);
            }
          },
        },

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Coupons',
            buttonRight: {
              label: '+ Create Coupon',
              permissions: 'COUPONS_CREATE',
              action: function () {
                $scope.couponsList.createCoupon();
              },
            },
          });

          if (PermissionsService.check('COUPONS_DELETE')) {
            $scope.couponsList.optionsOverride.columnDefs.push({
              field: 'remove',
              displayName: 'Remove',
              onCellNavClick: function (row, col) {
                $scope.couponsList.removeCoupon(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>',
            });
          }

          if (PermissionsService.check('COUPONS_UPDATE')) {
            $scope.couponsList.optionsOverride.columnDefs.unshift({
              field: 'edit',
              displayName: 'Edit',
              width: 50,
              onCellNavClick: function (row, col) {
                $scope.couponsList.onDblClick(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            });
          }

          this.viewId = $state.current.name;
          this.gridDefinition.init(
            this.gridName,
            this.optionsOverride,
            this.viewId,
            $state.current.data.enablePreferences
          );

          this.getCouponCategories();
          this.getAccounts();

          $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
        },

        initData: function (e, data) {
          var self = $scope.couponsList;
          var props = self.gridDefinition.getGridState();
          self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
          self.search();
        },

        query: function () {
          var self = $scope.couponsList;
          self.gridState.setPropertyValue('search', self.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: self.gridName });
        },

        search: function () {
          this.isLoaded = false;
          if (this.gridDefinition.userPreferencesLoaded) {
            this.getCouponsList();
          }
        },

        checkPermissions: function (permission) {
          var r = false;
          if (permission) {
            r = PermissionsService.check(permission);
          }
          return r;
        },

        getCouponsList: function () {
          ApiService.coupons
            .list(this.gridState.getGridState())
            .then(this.success.getCouponsList, this.error.getCouponsList);
        },

        getCouponCategories: function () {
          ApiService.coupons.categories
            .list(HelpersService.getPaginator())
            .then(this.success.getCouponCategories, this.error.getCouponCategories);
        },

        getAccounts: function () {
          ApiService.partners
            .list(HelpersService.getPaginator())
            .then(this.success.getAccounts, this.error.getAccounts);
        },

        createCoupon: function () {
          var self = $scope.couponsList;
          self.addModal = $uibModal.open({
            templateUrl: 'views/application/views/coupons/list/modals/createCoupon.tpl.html',
            size: 'lg',
            controller: 'CreateCouponModalController',
            resolve: {
              coupons: function () {
                return self.model;
              },
              categories: function () {
                return self.categories;
              },
              accounts: function () {
                return self.accounts;
              },
            },
          });

          self.addModal.result.then(
            function (couponObj) {
              ApiService.coupons.create(couponObj.coupon).then(
                function (response) {
                  var props;

                  self.success.create(response);
                  if (response.data.payload.id) {
                    props = {
                      couponId: response.data.payload.id,
                      effectiveStartDate: couponObj.effectiveDate.effectiveStartDate,
                      effectiveEndDate: couponObj.effectiveDate.effectiveEndDate,
                      notes: couponObj.effectiveDate.notes,
                    };
                    ApiService.coupons.effectiveDates.create(props);
                  }
                },
                function (response) {
                  self.error.create(response);
                }
              );
            },
            function () {
              //do nothing;
            }
          );
        },

        removeCoupon: function (item) {
          var self = $scope.couponsList;
          var coupon = item.entity;

          self.removeModal = $uibModal.open({
            templateUrl: 'views/application/views/coupons/list/modals/removeCoupon.tpl.html',
            size: 'lg',
            controller: 'CouponRemoveModalController',
            resolve: {
              currentCoupon: function () {
                return coupon;
              },
            },
          });

          self.removeModal.result.then(
            function (coupon) {
              var self = $scope.couponsList;
              ApiService.coupons.remove(coupon.id).then(function (response) {
                self.search();
                self.success.remove(response);
              }, self.error.remove);
            },
            function () {
              //do nothing;
            }
          );
        },

        success: {
          getCouponsList: function (response) {
            var self = $scope.couponsList;
            self.model = response.data.payload.list;

            self.isLoaded = true;
            self.gridDefinition.isLoaded = true;

            $timeout(function () {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: self.gridDefinition.options.gridName,
                datasetLength: self.model.length,
                totalItems: response.data.payload.pagination.count,
              });
            });
          },

          getCouponCategories: function (response) {
            $scope.couponsList.categories = response.data.payload.list;
          },

          getAccounts: function (response) {
            $scope.couponsList.accounts = response.data.payload.list.map(function (account) {
              return account.company;
            });
          },

          create: function (response) {
            $scope.couponsList.search();
          },

          remove: function (response) {},
        },

        error: {
          getCouponsList: function (response) {},

          getCouponCategories: function (response) {
            $scope.couponsList.categories = [];
          },

          getAccounts: function (response) {},

          create: function (response) {},

          remove: function (response) {},
        },

        onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
          var self = $scope.couponsList;
          self.gridState.updateGridState(newPage, pageSize);
          if (sortField) {
            self.gridState.updateGridState(null, null, sortField, null);
          }
          if (sortDirection) {
            self.gridState.updateGridState(null, null, null, sortDirection);
          }
          self.search();
        },

        onDblClick: function (item) {
          $state.go('application.coupons.create.detail', { couponId: item.entity.id });
        },

        onDataGridSortChange: function (grid, columns, page) {
          var self = $scope.couponsList;
          var data = columns[0];
          self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          self.search();
        },
      };

      $scope.couponsList.init();
    },
  ]);